<template>
  <div :class="$style.wrapper">
    <div :class="$style.header">
      <template v-if="completed !== 3">
        <span :class="[$style.count, updated && $style.updated]">{{ completed }}</span> из 3
        <p>Найдено общих интересов</p>
      </template>
      <template v-else>
        Ура!
        <p>Ты нашел все общие интересы ребят</p>
      </template>
    </div>
    <div :class="$style.cards">
      <InterestCard
        v-for="(item, index) in cards"
         :key="index"
         :class="$style.cards__item"
        :avatar="item.avatar"
        :name="item.name"
        :age="item.age"
        :interests="item.interests"
        @interestSelected="id => interestSelect(id, index)"
      >
      </InterestCard>
    </div>
    <div :class="$style.button" v-if="completed === 3">
      <Button @click="$emit('completed')">Продолжить</Button>
    </div>
    <transition name="fade" mode="out-in">
      <LevelPopup
        title="Обучи нейросеть подбирать интересные новости"
        ref="popup"
        v-if="showPopup === 1"
        @close="showPopup += 1"
        key="popup1"
      >
        <template #icon>
          <img src="@/assets/lesson3/task3/icon.svg" alt=""  :style="{ width: $mq === 'sm' ? '4rem' : '9rem' }">
        </template>
        <template #description>
          <p>В социальных сетях нейросети широко применяются для решения разнообразных задач.
            Например, за подборку интересных новостей, постов, видео, музыки в твоей ленте отвечает
            рекомендательная система, использующая алгоритмы нейросети.
          </p>
        </template>
      </LevelPopup>
      <LevelPopup
        ref="popup"
        v-if="showPopup === 2"
        @close="showPopup = false; helpBox.show = true"
        key="popup2"
      >
        <template #icon>
          <img src="@/assets/lesson3/task3/icon.svg" alt=""  :style="{ width: $mq === 'sm' ? '4rem' : '9rem' }">
        </template>
        <template #description>
          <p>Как работает рекомендательная система?
            <br><br>
            Нейросеть изучает твои интересы, историю просмотренных постов, а также то, что привлекло других пользователей со схожими интересами.
            <br><br>
            На основе этих данных нейросеть подбирает интересный материал для твоей ленты.
          </p>
        </template>
      </LevelPopup>
    </transition>
    <HelpBox
      ref="helpbox"
      :type="helpBox.type"
      :description="helpBox.description"
      :show="helpBox.show"
      :width="52"
      :character="helpBox.character"
      warn-message="ОК"
      @close="helpBox.show=false"
      @open="showHint"
      @closeWarning="helpBox.show=false"
    />
  </div>
</template>

<script>
import InterestCard from '@/views/lesson3/components/task3/InterestCard'
import LevelPopup from '@/components/LevelPopup/LevelPopup'
import HelpBox from '@/components/HelpBox/HelpBox'
import Button from '@/components/Button/Button'

export default {
  name: 'index',
  components: {
    HelpBox, LevelPopup, InterestCard, Button,
  },
  data() {
    return {
      helpBox: {
        type: 'task',
        character: 'boy',
        description: 'Изучи анкеты героев, найди схожие интересы. Отметь общие интересы для всех трёх героев.',
        show: false,
      },
      updated: false,
      showPopup: false,
      completed: 0,
      cards: [
        {
          name: 'Скобец',
          avatar: require('@/assets/lesson3/task3/scb/avatar.png'),
          interests: [
            {
              src: require('@/assets/lesson3/task3/icon_animals.svg'),
              selected: false,
              name: 'Домашние животные',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 1,
            },
            {
              src: require('@/assets/lesson3/task3/code.svg'),
              selected: false,
              name: 'Программирование',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/books.svg'),
              selected: false,
              name: 'Литература',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/football.svg'),
              selected: false,
              name: 'Футбол',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 2,
            },
            {
              src: require('@/assets/lesson3/task3/PC_games.svg'),
              selected: false,
              name: 'Видеоигры',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/board_games.svg'),
              selected: false,
              name: 'Настольные игры',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 3,
            },
          ],
          age: '14 лет',
        },
        {
          name: 'Запятыня',
          avatar: require('@/assets/lesson3/task3/zap/avatar.png'),
          interests: [
            {
              src: require('@/assets/lesson3/task3/icon_trip.svg'),
              selected: false,
              name: 'Путешествия',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/code.svg'),
              selected: false,
              name: 'Программирование',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/basketball.svg'),
              selected: false,
              name: 'Баскетбол',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 2,
            },
            {
              src: require('@/assets/lesson3/task3/icon_animals.svg'),
              selected: false,
              name: 'Домашние животные',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 1,
            },
            {
              src: require('@/assets/lesson3/task3/board_games.svg'),
              selected: false,
              name: 'Настольные игры',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 3,
            },
            {
              src: require('@/assets/lesson3/task3/piano.svg'),
              selected: false,
              name: 'Игра на фортепиано',
              bg: this.randomColor(),
              bgFixed: false,
            },
          ],
          age: '15 лет',
        },
        {
          name: 'Маруся',
          avatar: require('@/assets/lesson3/task3/mar/avatar.png'),
          interests: [
            {
              src: require('@/assets/lesson3/task3/board_games.svg'),
              selected: false,
              name: 'Настольные игры',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 3,
            },
            {
              src: require('@/assets/lesson3/task3/icon_animals.svg'),
              selected: false,
              name: 'Домашние животные',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 1,
            },
            {
              src: require('@/assets/lesson3/task3/icon_english.svg'),
              selected: false,
              name: 'Английский язык',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/guitar.svg'),
              selected: false,
              name: 'Игра на гитаре',
              bg: this.randomColor(),
              bgFixed: false,
            },
            {
              src: require('@/assets/lesson3/task3/icon_tennis.svg'),
              selected: false,
              name: 'Теннис',
              bg: this.randomColor(),
              bgFixed: false,
              alikeId: 2,
            },
            {
              src: require('@/assets/lesson3/task3/books.svg'),
              selected: false,
              name: 'Литература',
              bg: this.randomColor(),
              bgFixed: false,
            },
          ],
          age: '16 лет',
        },
      ],
    }
  },
  computed: {
    selectedInterests() {
      const selected = []
      this.cards.forEach((item) => {
        if (item.interests.find(interest => interest.selected)) selected.push(item.interests.find(interest => interest.selected))
      })
      return selected
    },
  },
  watch: {
    completed(val) {
      if (val === 3) {
        this.helpBox = {
          type: 'task',
          character: 'boy',
          description: 'Изучи анкеты героев, найди схожие интересы. Отметь общие интересы для всех трёх героев.',
          show: false,
        }
      }

      this.updated = true
      setTimeout(() => {
        this.updated = false
      }, 500)
    },
  },
  created() {
    setTimeout(() => {
      this.showPopup = 1
    }, 1000)
  },
  methods: {
    nextPopup() {

    },
    randomColor() {
      return `#${Math.floor(Math.random() * 16777215).toString(16)}24`
    },
    checkIfAllSimilar() {
      if (this.selectedInterests.length === 3) {
        const alikeInterests = []
        this.selectedInterests.forEach((item) => {
          if (item.alikeId) alikeInterests.push(item.alikeId)
        })
        if (alikeInterests.length === 3 && new Set(alikeInterests).size === 1) {
          this.selectedInterests.forEach((item) => {
            item.bgFixed = true
            item.selected = false
          })
          this.completed += 1
          this.$emit('updateScore', 5)
        } else {
          this.selectedInterests.forEach((item) => { item.selected = false })
          this.showError()
        }
      }
    },
    interestSelect(id, cardIndex) {
      if (this.cards[cardIndex].interests.find(item => item.selected === true)) {
        this.cards[cardIndex].interests.find(item => item.selected === true).selected = false
      }
      this.cards[cardIndex].interests[id].selected = true
      this.checkIfAllSimilar()
    },
    showHint() {
      this.helpBox.show = true
      this.helpBox.type = 'task'
      this.helpBox.description = 'Изучи анкеты героев, найди схожие интересы. Отметь общие интересы для всех трёх героев.'
    },
    showError() {
      this.helpBox.show = true
      this.helpBox.type = 'warning'
      this.helpBox.description = 'Обрати внимание, какие интересы общие у трёх героев. Интересы могут называться по разному, но относиться к одной категории.'
    },
  },
}
</script>

<style lang="scss" module>
@keyframes updated {
  0% {
    transform: scale(1);
    color: #fff;
  }
  50% {
    transform: scale(2);
    color: $color-green;
  }
  100%{
    transform: scale(1);
    color: #fff;
  }
}

.wrapper{
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .header{
    color: white;
    width: 100%;
    margin-top: 3rem;
    font-size: 5.2rem;
    font-weight: bold;
    text-align: center;
    p{
      font-size: 2.1rem;
      font-weight: normal;
    }

    @media #{$m-mobile} {
      font-size: 2.4rem;
      margin-bottom: 2rem;

      p {
        font-size: 1.8rem;
        margin-bottom: 0;
      }
    }
  }
  .cards{
    display: flex;
    justify-items: center;
    min-height: min-content;
    @media #{$m-mobile} {
      margin-bottom: 5rem;
    }
    &__item{
      height: 43.2rem;
      width: 28.5rem;
      & + .cards__item{
        margin-left: 3.5rem;
      }
      @media #{$m-mobile} {
        width: 20rem;
        height: 25rem;
      }
    }
  }
}

.count {
  display: inline-block;
}

.count.updated {
  animation: updated 0.5s ease forwards;
}

.button {
  margin-top: 6rem;
  margin-bottom: 6rem;

  @media #{$m-mobile} {
    margin-top: -4rem;
  }
}
</style>
